export const SUBSCRIBERS_TABLE_ID = 'subscribers-table';
